var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SidebarBase',{scopedSlots:_vm._u([{key:"categories",fn:function(ref){
var visibleCategoriesTree = ref.visibleCategoriesTree;
return [_c('ul',_vm._l((visibleCategoriesTree),function(c){return _c('CategoryInlineNested',{key:c.id,attrs:{"category":c}})}),1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }